import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  PERMISSION_MAP_CHARTS_WRITE,
  PERMISSION_VACANCIES_READ
} from '../../constants'
import ProtectedElement from '../common/helpers/ProtectedElement'
import WithAjax from '../common/helpers/WithAjax'
import {clearMapCharts, fetchMapChartsManageSuccess} from '../../actions/pages/map-charts-page'

class MapManage extends Component {
  constructor(){
    super();
    this.onUpload = this.onUpload.bind(this)
    this.onFileChange = this.onFileChange.bind(this)
    this.onPublish = this.onPublish.bind(this)
    this.convertToFormData = this.convertToFormData.bind(this)
    this.state={
      selectedFile: null
    }
    this.dataDimensions = []
  }
  componentDidMount(){
    this.fetchDimension();
  }
  componentDidUpdate(prevProps){
    if (this.props.manage === null &&!this.props.isLoading) {
      this.fetchDimension();
    }
  }
  fetchDimension(){
    let url = 'geo';
    this.props.clearMapCharts();


    this.props.ajax.get(url, true, (data) => {
      this.props.fetchMapChartsManageSuccess(data);
      this.dataDimensions = []
      {data.Dimensions.map((element, index) => {
        if(element.IsDraft == true){
          this.dataDimensions.push(element)
        }
      })}
    });
  }
  onUpload(){
    if(!this.state.selectedFile){
      alert("Please select an Excel file containing geo charts")
      return false;
    }
    let url = 'geo/upload';
    let formData = this.convertToFormData(this.state.selectedFile);
    this.props.ajax.post(url, formData, null, (response) => {
      if(response.status == '200'){
        this.fetchDimension();
        this.props.history.push('/map-charts/manage')
      }else{
        alert('The geo chart data file has one or more issues. Please check the file and try again.\n\n' + response);
      }
    })
    document.getElementById('geo-file').value = ''
    this.setState({selectedFile: null})

  }
  onPublish(){
    let url = 'geo/publish';

    this.props.ajax.put(
      url,
      null,
      null,
      (response) => {
        if(response.status == 200){
          this.props.history.push('/map-charts/overview')
        }else{
          alert(response);
        }
      })
  }
  onFileChange(e){
    this.setState({
      selectedFile:e.target.files[0],
      loaded:0
    });
  }
  convertToFormData(data){
    var formData = new FormData();;
    formData.append("file", data);

    return formData;
}
  render() {
    if (this.props.overview === null) {
      return (<div />)
    }
    if (this.dataDimensions !== null){
      return (
        <React.Fragment>
          {this.dataDimensions.length > 0 ?
            <ProtectedElement permission={PERMISSION_MAP_CHARTS_WRITE}>
              <button id="publish" className="btn btn-rounded btn-primary btn pull-right" onClick={this.onPublish}>Publish</button>
            </ProtectedElement>
            :
            ''
          }
          {this.dataDimensions.map((element, index) => (
            <div key={index}>
              <div className="row">
                <div className="col-12">
                  <h5 style={{marginTop: '10px'}}>{element.Label}</h5>
                  <p>{element.Description}</p>
                </div>
              </div>
              <div className="row" style={{marginBottom: '50px'}}>
                {element.MapUrls.map((element, index) => (
                  <div key={index} className="col-12 col-md-4 text-center">
                    <a href={element.Value}>
                      <img src={element.Value} style={{width:'75%'}}/>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <ProtectedElement permission={PERMISSION_MAP_CHARTS_WRITE}>
            <div className="row">
              <div className="col">
                <p>Select an Excel file containing geo charts data you would like to publish.</p>
                <div className="input-group">
                  <input id="geo-file" className="mb-3" type="file"  accept=".xlsx, .xls, .xml" onChange={this.onFileChange} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                  <button id="upload" className="btn btn-rounded btn-primary" onClick={this.onUpload}>Upload</button>
                  {this.dataDimensions.length > 0 ?
                    <button id="publish" className="btn btn-rounded btn-primary btn pull-right" onClick={this.onPublish}>Publish</button>
                    :
                    ''
                  }
              </div>
            </div>
          </ProtectedElement>
        </React.Fragment>
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  manage: state.mapChartsPage.manage,
  isLoading: state.common.isLoading
})
const mapDispatchToProps = dispatch => ({
  clearMapCharts() { dispatch(clearMapCharts()) },
  fetchMapChartsManageSuccess(manage) { dispatch(fetchMapChartsManageSuccess(manage)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(MapManage))
